import React from 'react';
import { Spinner, Flex } from '@chakra-ui/react';

const Loading = () => {
  return (
    <>
      <Flex align="center" justify="center">
        <Spinner color="blue.500" borderWidth="4px" size="xl" />
      </Flex>
    </>
  );
};

export default Loading;
